import
  React, {
  useContext,
  useEffect
} from 'react';

import {
  useHistory
} from 'react-router-dom';

import {
  Base,
  JourneyProvider,
  Text,
  TileCard,
  VContainer
} from '@vodacom/web-common';

import {
  Environment
} from '@vodacom/web-env';

import
  dayjs
from 'dayjs';

import {
  BackButton,
  InfoCard
} from 'components';

import {
  CacheKeys,
  OriginContexts
} from '../../../constants';

import {
  DrupalProvider
} from 'providers';

import {
  HandleRender,
  withScreenViewTagging
} from 'hocs';

import {
  AppContext
} from 'context';

import {
  isEqual,
  openDeeplink,
  useRedirectHandler
} from 'helpers';

const WhatsNewUI = () => {

  const { config } = useContext(AppContext);
  const history = useHistory();
  const mountedRef = React.useRef(true);

  const [
    state,
    setState
  ] = React.useState({
    loading: true,
    error: null,
    topics: [],
    showInfoCard: JourneyProvider.get('Common', 'showInfoCard', 'yes')
  });

  const context = JourneyProvider.get(CacheKeys.ConfigContext, 'value', '');
  const redirectHandler = useRedirectHandler();

  useEffect(() => {

    const init = async () => {

      await getWhatsNew();
    };

    init();

    return () => {
      mountedRef.current = false;
    };
  }, []);

  const buildTopics = () => {

    let topicTiles = [];

    topicTiles.push(

      <VContainer
        key={'info-card'}
        margin={'14px 0 14px 0'}
        width={'100%'}>

        { state.showInfoCard === 'yes' &&

          <InfoCard
            title={config?.whatsNewBannerTitle}
            content={config?.whatsNewBannerContent}
            onClose={() => {

              JourneyProvider.set('Common', { showInfoCard: 'no' }, true);
              setState(prevState => ({
                ...prevState,
                showInfoCard: 'no'
              }));
            }}/>
        }
      </VContainer>
    );

    if (!state.topics?.length > 0) {
      return topicTiles;
    }

    let topics = state.topics;

    if (!topics || !Array.isArray(topics)) {
      return topicTiles;
    }

    topics.forEach((topic) => {

      if (!topic || (isEqual(context, OriginContexts.VodaPay) && topic.hideOnVodapay)) {
        return;
      }

      let d = dayjs(topic.created).format('DD MMM YYYY');

      topicTiles.push(

        <TileCard
          margin='0 0 16px 0'
          key={topic.id}
          image={`${Environment.current.drupalBaseUrl}${topic.image}`}
          subtitle={d}
          title={topic.title}
          text={topic.summary}
          isTextHTML={true}
          buttonText={'Find out more'}
          buttonActiveOpacity={'0.25'}
          buttonMinWidth={'92%'}
          onClick={() => {

            if (topic.vodaypayAppId && isEqual(context, OriginContexts.VodaPay)) {

              openDeeplink(topic.vodaypayAppId);

              return;
            }

            if (!topic.hasConnectuPage) {

              redirectHandler(
                history.location,
                `/redirect?targetUrl=${encodeURIComponent(topic.url)}&isZeroRated=${topic.isZeroRated}`,
                topic.isZeroRated
              );
              return;
            }

            history.push({
              pathname: `/whats-new/${topic.id}`
            });
          }} />
      );
    });
    return topicTiles;
  };

  const getWhatsNew = async () => {

    const topics = await DrupalProvider.getCachedItem(CacheKeys.WhatsNew, null, DrupalProvider.getWhatsNew);

    if (!mountedRef.current) {
      return;
    }

    if (!topics || !topics.ok) {
      setState(prevState => ({
        ...prevState,
        loading: false,
        error: true
      }));
      return;
    }

    setState(prevState => ({
      ...prevState,
      loading: false,
      topics: topics?.result?.[0]?.content
    }));
  };

  return (

    <HandleRender
      isLoading={state.loading}
      isError={state.error}>

      <VContainer
        padding='0 15px 0 15px'>

        <BackButton
          maxWidth='100%'
          margin='24px 0 0 0'
          onClick={() => history.goBack()} />

        <Base
          padding={'16px 0 0 0'}>
          <Text
            fontSize={'16px'}
            fontWeight={'bold'}>

              {'What\'s New'}
          </Text>
        </Base>

        {buildTopics()}
      </VContainer>
    </HandleRender>
  );
};

WhatsNewUI.pageName = 'cbu: connectu: what is new';
WhatsNewUI.tagViewData = {
  page_section: 'what is new'
};

export const WhatsNew = withScreenViewTagging(WhatsNewUI);